import { Route, Switch, useLocation } from "react-router-dom";
import LandingPage from "../pages/Landing/LandingPage";
import Layout from "../Layouts/Layout";
import ShoppingCart from "../pages/ShoppingCart/ShoppingCart";
import Login from "../pages/Login/Login";
import EmailConfirmation from "../pages/EmailConfirmation/EmailConfirmation";
import React, { lazy, Suspense } from "react";
import Loading from "../components/Loading/Loading";
import businessPartnerImg from "../pages/images/businesspartner/businesspartner-bg.jpg";
import areaManagerImg from "../pages/images/areamanager/areamanager-bg.jpg";
import salePromoterImg from "../pages/images/salepromoter/salepromoter-bg.jpg";
import specialCustomerImg from "../pages/images/specialcustomer/specialcustomer-bg.jpg";
import UnderConstruction from "../pages/UnderConstruction/UnderConstruction";
import Shop from "../pages/Shop/Shop";
import ProductInfo from "../pages/ProductInfo/ProductInfo";
import UserStorePage from "../pages/UserStorePage/UserStorePage";
import PrivacyPolicy from "../pages/privacypolicy/PrivacyPolicy";
import CategoriesPage from "../pages/CategoriesPage/CategoriesPage";

const StoreRoutes = () => {
  const RegisterUserLazy = lazy(() => import("../pages/RegisterUser/RegisterUser"));

  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let origin = window.location.origin.toString();
  const HomeComponent =
    origin === "https://business.extraconomy.com" ||
    origin === "https://apptest-business.extraconomy.com"
      ? LandingPage
      : Shop;

  return (
    <Switch>
      <Route path="/landing" component={LandingPage} />
      <Route
        path="/cart-fringe-benefit"
        render={() => (
          <Layout>
            <ShoppingCart />
          </Layout>
        )}
      />
      <Route
        path="/cart"
        render={() => (
          <Layout>
            <ShoppingCart />
          </Layout>
        )}
      />
      <Route path="/login" render={() => <Login />} />
      <Route
        path="/emailconfirmation"
        render={() => (
          <Layout>
            <EmailConfirmation
              message={query.get("message")}
              title={query.get("title")}
              type={query.get("type")}
            />
          </Layout>
        )}
      />
      <Route
        path="/orderconfirmation"
        render={() => (
          <Layout>
            <EmailConfirmation
              message={query.get("message")}
              title={query.get("title")}
              type={query.get("type")}
              url={query.get("url")}
            />
          </Layout>
        )}
      />
      <Route
        path="/businesspartner"
        render={() => (
          <Suspense fallback={<Loading />}>
            <RegisterUserLazy
              img={businessPartnerImg}
              plan="businesspartner"
              link={query.get("link")}
            />
          </Suspense>
        )}
      />
      <Route
        path="/areamanager"
        render={() => (
          <Suspense fallback={<Loading />}>
            <RegisterUserLazy img={areaManagerImg} plan="areamanager" link={query.get("link")} />
          </Suspense>
        )}
      />
      <Route
        path="/specialcustomer"
        render={() => (
          <Suspense fallback={<Loading />}>
            <RegisterUserLazy
              img={specialCustomerImg}
              plan="specialcustomer"
              link={query.get("link")}
            />
          </Suspense>
        )}
      />
      <Route
        path="/seller"
        render={() => (
          <Suspense fallback={<Loading />}>
            <RegisterUserLazy img={specialCustomerImg} plan="seller" link={query.get("link")} />
          </Suspense>
        )}
      />
      <Route
        path="/salepromoter"
        render={() => (
          <Suspense fallback={<Loading />}>
            <RegisterUserLazy img={salePromoterImg} plan="salepromoter" link={query.get("link")} />
          </Suspense>
        )}
      />
      <Route
        path="/registerstore"
        render={() => (
          <Suspense fallback={<Loading />}>
            <RegisterUserLazy img={specialCustomerImg} plan="store" link={query.get("link")} />
          </Suspense>
        )}
      />
      <Route path="/comingsoon" render={() => <UnderConstruction />} />
      <Route
        path="/shop"
        render={() => (
          <Layout hasSearch={true}>
            <Shop search={query.get("search")} />
          </Layout>
        )}
      />
      <Route
        path="/product"
        render={() => (
          <Layout hasSearch={true}>
            <ProductInfo id={query.get("id")} />
          </Layout>
        )}
      />
      <Route
        path="/store"
        render={() => (
          <Layout hasSearch={true}>
            <UserStorePage user={query.get("user")} />
          </Layout>
        )}
      />
      <Route
        path="/privacy"
        render={() => (
          <Layout>
            <PrivacyPolicy />
          </Layout>
        )}
      />
      <Route
        path="/categories"
        render={() => (
          <Layout hasSearch={true}>
            <CategoriesPage />
          </Layout>
        )}
      />
      <Route
        path="/fringe-benefit"
        render={() => (
          <Layout hasSearch={true}>
            <ProductInfo id={query.get("id")} />
          </Layout>
        )}
      />
      <Route
        path="/fringe-benefits"
        render={() => (
          <Layout hasSearch={true}>
            <Shop search={query.get("search")} />
          </Layout>
        )}
      />
      <Route
        path="/"
        render={() =>
          HomeComponent === LandingPage ? (
            <LandingPage />
          ) : (
            <Layout hasSearch={true}>
              <HomeComponent search={query.get("search")} />
            </Layout>
          )
        }
      />
    </Switch>
  );
};

export default StoreRoutes;
